import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import './style.less';

const packageCardList = [
  {
    title: 'VIP云手机',
    img: require('@/assets/img/vip@3x.png'),
    description: [
      '安卓系统5.1版本',
      '标准稳定配置',
      '超赞稳定性能'
    ]
  },
  {
    title: 'GVIP云手机',
    img: require('@/assets/img/GVIP@3x.png'),
    description: [
      '安卓系统5.1版本',
      '原生手机体验',
      '专有专属网络'
    ]
  },
  {
    title: 'SVIP云手机',
    img: require('@/assets/img/basis@3x.png'),
    description: [
      '安卓系统7.1版本',
      '更多游戏兼容',
      '更稳挂机体验'
    ]
  }
]

interface IPackageCard {
  type?: any
}

@Component
export default class PackageCard  extends tsx.Component<IPackageCard> {
  
  @Prop() public type?: any
  
  constructor(props: any) {
    super(props)
  }
  
  render() {
    const {type} = this.$props;
    return (
      
      <div class='packageCard-container' style={`background: url(${packageCardList[Number(type)].img}) 100%/100%`}>
        <h3 class='title'>{packageCardList[Number(type)].title}</h3>
        {packageCardList[Number(type)].description.map((text: string, index: number) => <p class='description' key={index}>{text}</p>)}
      </div>
    )
  }
  
}
